import React from "react";

// Displays an image in FULL (never cropped) inside a fixed-size frame.
// A blurred, scaled copy of the same image fills the letterbox area so there
// are never empty/black bars around portrait or landscape uploads.
export const FullImage = ({ src, alt = "", className = "", imgClassName = "", testId, children }) => (
  <div className={`relative overflow-hidden ${className}`}>
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-40"
    />
    <img
      src={src}
      alt={alt}
      loading="lazy"
      data-testid={testId}
      className={`relative z-[1] w-full h-full object-contain ${imgClassName}`}
    />
    {children}
  </div>
);

export default FullImage;
